module.exports = __webpack_public_path__ + "static/media/circle-icon.b4bb8e10.svg";